import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import heroImage from '../images/mazguard-hero.png';
import Footer from './Footer';

export default function Layout() {
  return (
    <Box
      sx={{
        backgroundImage: `url(${heroImage})`,        
        // backgroundImage: `url('https://media.licdn.com/dms/image/v2/D5612AQGhl0gO75T52Q/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1679390033979?e=2147483647&v=beta&t=SRFf75fE0VLfceMpuQTf-VCh5w-mjvR1dik_AstqcmM')`,
        // backgroundImage: `url('https://www.shutterstock.com/image-photo/change-concept-woman-hand-turning-600nw-1045399849.jpg')`,
        // backgroundImage: `url('https://images.unsplash.com/photo-1508780709619-79562169bc64?auto=format&fit=crop&w=1600&q=80')`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        minHeight: '100vh',
        width: '100%',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 100,
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }}
      >
        <Navbar />
      </Box>

      <Box
        sx={{
          backgroundColor: 'rgba(0, 50, 20, 0.5)',
          flex: 1,
          minHeight: '100vh',
          // px: { xs: 2, sm: 4, md: 6 },
          py: { xs: 8, sm: 10 }, // Top padding adjusted to make room for fixed navbar
        }}
        component={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Outlet />        
      </Box>
      <Footer/>     
    </Box>
  );
}
